import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { EngineService } from '@/services/engine/engine-service';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import type { CreateReportPayload, Report } from '@/types/report';

export function useCreateReport() {
    const { t } = useTranslation(I18nNamespace.REPORTS);

    return async (payload: CreateReportPayload): Promise<Report> => {
        try {
            const report = await EngineService.createReport(payload);
            toast.success(t('createSuccess'));
            return report;
        } catch (error) {
            toast.error(t('createError'));
            throw error;
        }
    };
}
